import { useEffect } from 'react'
import { useParams } from '@tanstack/react-router'
import { Header } from 'components/layout/header'
import { Main } from 'components/layout/main'
import { Search } from 'components/search'
import { fetchReport } from 'store/reports/reportsSlice'
import { useAppDispatch, useAppSelector } from 'store/store'
import { SolveReportForm } from 'ui/components/SolveReportForm'

export const EditReportPage = () => {
  const { id } = useParams({ from: '/protected/segnalazioni/$id/risolvi' }) as {
    id: string
  }
  const dispatch = useAppDispatch()
  const { report } = useAppSelector((state) => state.reports)

  useEffect(() => {
    if (id) {
      const numericId = parseInt(id, 10)
      if (!isNaN(numericId)) {
        dispatch(fetchReport(numericId))
      }
    }
  }, [dispatch, id])

  return (
    <>
      {/* ===== Top Heading ===== */}
      <Header>
        <div className='ml-auto flex items-center space-x-4'>
          <Search />
        </div>
      </Header>

      {/* ===== Main ===== */}
      <Main>
        <div className='mb-2 flex flex-wrap items-center justify-between space-y-2 gap-x-4'>
          <div>
            <h2 className='text-2xl font-bold tracking-tight'>
              Gestione Report
            </h2>
            <p className='text-muted-foreground'>Gestione singolo report</p>
          </div>
        </div>
        <div className='-mx-4 mt-5 flex-1 overflow-auto px-4 py-1 lg:flex-row lg:space-y-0 lg:space-x-12'>
          <SolveReportForm {...report} />
        </div>
      </Main>
    </>
  )
}

export default EditReportPage
